import { useState } from "react";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const GOLD = {
  caption_label: "text-sm font-display tracking-wide text-[#F3E5AB]",
  nav_button: "h-7 w-7 rounded-full border border-[#D4AF37]/30 text-[#D4AF37] hover:bg-[#D4AF37]/10 inline-flex items-center justify-center",
  head_cell: "text-[#6E6865] w-9 font-normal text-[0.7rem] uppercase tracking-wider",
  cell: "p-0 text-center text-sm",
  day: "h-9 w-9 rounded-full text-[#D8D2CE] hover:bg-[#7A1426]/40 hover:text-[#F3E5AB] inline-flex items-center justify-center transition-colors",
  day_selected: "bg-[#7A1426] text-[#F3E5AB] border border-[#D4AF37]/60 hover:bg-[#941B30]",
  day_today: "ring-1 ring-[#D4AF37] text-[#D4AF37]",
  day_outside: "text-[#3a3538]",
};

export default function DatePicker({ value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="w-full flex items-center gap-2 px-3 py-2.5 rounded-lg bg-[#0B0A0C] border border-[#D4AF37]/20 text-left text-sm hover:border-[#D4AF37]/50 transition-colors">
          <CalendarDays className="w-4 h-4 text-[#D4AF37]" />
          <span className={date ? "text-[#FBF8F5] capitalize" : "text-[#6E6865]"}>
            {date ? format(date, "EEEE d MMMM yyyy", { locale: it }) : "Scegli una data"}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0 bg-[#141217] border border-[#D4AF37]/30 rounded-2xl shadow-[0_0_40px_rgba(212,175,55,0.15)]">
        <Calendar mode="single" locale={it} selected={date} defaultMonth={date} classNames={GOLD}
          onSelect={(d) => { if (d) onChange(format(d, "yyyy-MM-dd")); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
}
